import { render } from "./Entry.vue?vue&type=template&id=dbbf0f3c&scoped=true"
import script from "./Entry.vue?vue&type=script&lang=ts"
export * from "./Entry.vue?vue&type=script&lang=ts"

import "./Entry.vue?vue&type=style&index=0&id=dbbf0f3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dbbf0f3c"

export default script